<template>
  <div
    class="offcanvas offcanvas-bottom h-100 bg-primary-grasient"
    id="MagicRemoteJoystick"
    aria-labelledby="MagicRemoteJoystick"
    ref="MagicRemoteJoystick"
    data-bs-scroll="true"
  >
    <!-- offcanvas-header -->
    <div class="offcanvas-header d-block container-lg">
      <healper @back="closeOffcanvas">
        <template #right>
          <BtnHome
            @gohome="
              closeOffcanvas();
              $router.replace({ name: 'home' });
            "
          />
        </template>
      </healper>
      <p
        class="offcanvas-title text-center fs-4"
        id="MagicRemoteJoystick"
        v-t="'magic_remote.ksk'"
      ></p>
    </div>

    <div class="offcanvas-body d-flex align-items-center">
      <section class="w-100 container-lg">
        <div class="row">
          <!--* ================= ЛЕВЫЙ БЛОК ================= *-->
          <div class="col-12 col-md-4">
            <!-- Блок кнопок: Выключить звук / TV-гид -->
            <div class="row gx-3">
              <!-- Кнопка отключения звука (mute) -->
              <div class="col-6 ps-0">
                <button
                  class="btn btn-secondary bg-secondary bg-opacity-05 border-0 w-100 d-flex align-items-center justify-content-center"
                  @click="sendNewCommand('mute', '', 'volume_control')"
                >
                  <IconComponent :lib="'material'" :icon="'volume_off'" />
                </button>
              </div>

              <!-- Кнопка телегида (TV guide) -->
              <div class="col-6 pe-0">
                <button
                  class="btn btn-secondary bg-secondary bg-opacity-05 border-0 w-100"
                  @click="sendNewCommand('button', 'TV-guide')"
                  v-t="'magic_remote.buttons.tv-guide'"
                ></button>
              </div>
            </div>

            <!-- Блок управления громкостью и переключением каналов -->
            <div class="row gx-3 mt-5">
              <!-- Колонка: Громкость (плюс / минус) -->
              <div class="col-6 text-center">
                <!-- Увеличить громкость (зажатие) -->
                <button
                  class="btn btn-secondary bg-secondary bg-opacity-05 square-joystick-btn"
                  @mousedown="startDecrement(1)"
                  @mouseup="stopAction"
                  @mouseleave="stopAction"
                  @touchend="stopAction"
                  @touchcancel="stopAction"
                  :disabled="volume === 100"
                >
                  <i class="bi bi-plus-lg"></i>
                </button>

                <!-- Отображение текущего уровня громкости -->
                <div class="my-5">
                  <IconComponent :lib="'material'" :icon="'volume_up'" />
                </div>

                <!-- Уменьшить громкость (зажатие) -->
                <button
                  class="btn btn-secondary bg-secondary bg-opacity-05 square-joystick-btn"
                  @mousedown="startDecrement(-1)"
                  @mouseup="stopAction"
                  @mouseleave="stopAction"
                  @touchend="stopAction"
                  @touchcancel="stopAction"
                  :disabled="volume === 0"
                >
                  <i class="bi bi-dash-lg"></i>
                </button>
              </div>

              <!-- Колонка: Каналы (вверх / вниз) -->
              <div class="col-6 text-center">
                <!-- Канал вверх -->
                <button
                  class="btn btn-secondary bg-secondary bg-opacity-05 square-joystick-btn"
                  @click="sendNewCommand('button', 'ch-up')"
                >
                  <i class="bi bi-chevron-up"></i>
                </button>

                <!-- Буква "P" (символ канала) -->
                <div class="my-5">P</div>

                <!-- Канал вниз -->
                <button
                  class="btn btn-secondary bg-secondary bg-opacity-05 square-joystick-btn"
                  @click="sendNewCommand('button', 'ch-down')"
                >
                  <i class="bi bi-chevron-down"></i>
                </button>
              </div>
            </div>
          </div>

          <!--* ================= ЦЕНТРАЛЬНЫЙ БЛОК ================= *-->
          <div class="col-12 col-md-4 d-flex align-items-center justify-content-center">
            <!-- Кнопка включения/выключения питания (Power) -->
            <button
              class="btn btn-secondary bg-secondary bg-opacity-05 border-0 d-flex align-items-center justify-content-center square-joystick-btn"
              @click="sendNewCommand('button', 'power')"
            >
              <i class="bi bi-power fs-3"></i>
            </button>
          </div>

          <!--* ================= ПРАВЫЙ БЛОК ================= *-->
          <div class="col-12 col-md-4">
            <!-- Блок кнопок: Назад / Стоп (Home) -->
            <div class="row gx-3">
              <!-- Кнопка "Назад" (Back) -->
              <div class="col-6 ps-0">
                <button
                  class="btn btn-secondary bg-secondary bg-opacity-05 border-0 w-100 d-flex align-items-center justify-content-center"
                  @click="sendNewCommand('button', 'back')"
                >
                  <IconComponent :lib="'filoxenia'" :icon="'ArrowBack'" class="me-2" />
                  {{ $t("buttons.back") }}
                </button>
              </div>

              <!-- Кнопка "Стоп" (Home / Stop) -->
              <div class="col-6 pe-0">
                <button
                  class="btn btn-secondary bg-secondary bg-opacity-05 border-0 w-100"
                  @click="sendNewCommand('button', 'home')"
                  v-t="'buttons.stop'"
                ></button>
              </div>
            </div>

            <!-- Кольцо навигации (D-pad) -->
            <div class="nav-ring m-auto mt-5 bg-secondary bg-opacity-05">
              <!-- Вверх -->
              <button
                class="btn bg-transparent square-joystick-btn nav-btn up"
                @click="sendNewCommand('button', 'up')"
              >
                <i class="bi bi-caret-up-fill"></i>
              </button>

              <!-- Влево -->
              <button
                class="btn bg-transparent square-joystick-btn nav-btn left"
                @click="sendNewCommand('button', 'left')"
              >
                <i class="bi bi-caret-left-fill"></i>
              </button>

              <!-- Центральная кнопка OK -->
              <button class="nav-btn ok" @click="sendNewCommand('button', 'ok')">
                OK
              </button>

              <!-- Вправо -->
              <button
                class="btn bg-transparent square-joystick-btn nav-btn right"
                @click="sendNewCommand('button', 'right')"
              >
                <i class="bi bi-caret-right-fill"></i>
              </button>

              <!-- Вниз -->
              <button
                class="btn bg-transparent square-joystick-btn nav-btn down"
                @click="sendNewCommand('button', 'down')"
              >
                <i class="bi bi-caret-down-fill"></i>
              </button>
            </div>
          </div>

          <!--* ================= БЛОК MULTIMEDIA ================= *-->
          <div class="col-12 mt-5">
            <MagicRemoteMultimadia
              @movieControl="
                sendNewCommand($event.type, $event.value, $event.command, $event.property)
              "
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Offcanvas } from "bootstrap";

import type { IComandData } from "@/@types/connection/tvs";

import BtnHome from "../app/buttons/btn-home.vue";
import StandartHelpPanel from "@/components/app/headers/healps/standart-help-panel.vue";
import IconComponent from "../app/_shared/icons/icon-component.vue";
import MagicRemoteMultimadia from "./magic-remote-multimadia.vue";

@Options({
  components: {
    BtnHome,
    healper: StandartHelpPanel,
    IconComponent,
    MagicRemoteMultimadia,
  },
})
class MagicRemoteJoystick extends Vue {
  private offcanvasInstance: Offcanvas | null = null;
  actionInterval!: ReturnType<typeof setInterval>;
  actionTimer!: ReturnType<typeof setTimeout>;

  actionDelay = 200; // задержка перед началом залипания
  actionSpeed = 50; // скорость изменения при залипании
  isPressing = false;

  volume = 50;

  $refs!: { MagicRemoteJoystick: HTMLDivElement };

  get offcanvasElement(): HTMLDivElement {
    return this.$refs.MagicRemoteJoystick as HTMLDivElement;
  }

  mounted() {
    this.$nextTick(() => this.initializeOffcanvas());
    this.offcanvasElement?.addEventListener("touchend", this.blurOnTouch);
    this.offcanvasElement?.addEventListener("click", this.blurOnTouch);
    this.offcanvasElement?.addEventListener("touchstart", this.onTouchStart, {
      passive: true,
    });
    this.offcanvasElement?.addEventListener("touchend", this.onTouchEnd, {
      passive: true,
    });
    this.offcanvasElement?.addEventListener("touchcancel", this.onTouchEnd, {
      passive: true,
    });
  }

  pressedButton: HTMLElement | null = null;

  onTouchStart = (e: TouchEvent): void => {
    const el = (e.target as HTMLElement | null)?.closest("button");
    if (el) {
      this.pressedButton = el;
      el.classList.add("is-pressed");
    }
  };

  onTouchEnd = (): void => {
    if (this.pressedButton) {
      this.pressedButton.classList.remove("is-pressed");
      this.pressedButton = null;
    }
  };

  blurOnTouch = (): void => {
    const active = document.activeElement as HTMLElement | null;
    if (active && typeof active.blur === "function") active.blur();
  };

  private initializeOffcanvas() {
    if (this.offcanvasElement) {
      this.offcanvasInstance = new Offcanvas(this.offcanvasElement);
    }
  }

  public openOffcanvas(): void {
    this.offcanvasInstance?.show();
  }

  public closeOffcanvas(): void {
    this.offcanvasInstance?.hide();
  }

  decrementVolume() {
    this.sendNewCommand("volume", this.volume, "volume_control");
  }

  startDecrement(step: number) {
    this.isPressing = true;
    // сразу выполняем одно нажатие
    if (step === 1) this.volume++;
    if (step === -1) this.volume--;
    this.decrementVolume();
    // устанавливаем задержку перед началом залипания
    this.actionTimer = setTimeout(() => {
      if (this.isPressing) {
        // начинаем залипание
        this.actionInterval = setInterval(() => {
          if (this.isPressing) {
            if (step === 1) {
              if (this.volume !== 100) this.volume++;
              else this.stopAction();
            }
            if (step === -1) {
              if (this.volume !== 0) this.volume--;
              else this.stopAction();
            }
            this.decrementVolume();
          } else {
            this.stopAction();
          }
        }, this.actionSpeed); // скорость залипания (можно настроить)
      }
    }, this.actionDelay);
  }

  stopAction() {
    clearTimeout(this.actionTimer);
    clearInterval(this.actionInterval);
  }

  /**
   *
   * @param type     comand name
   * @param value    comand value
   * @param command  'mr_control'
   * @param property необязательное доп. поле (например, процент 0–100
   *                 для set_current_time — перемотка аудио на ТВ)
   */
  sendNewCommand(
    type: string,
    value: string | number | boolean = "",
    command = "mr_control",
    property?: string
  ): void {
    const command_data: IComandData = { type, value };
    if (property !== undefined) command_data.property = property;
    this.$emit("sendNewCommand", command, command_data);
  }

  beforeUnmount(): void {
    this.offcanvasElement?.removeEventListener("touchend", this.blurOnTouch);
    this.offcanvasElement?.removeEventListener("click", this.blurOnTouch);
    this.offcanvasElement?.removeEventListener("touchstart", this.onTouchStart);
    this.offcanvasElement?.removeEventListener("touchend", this.onTouchEnd);
    this.offcanvasElement?.removeEventListener("touchcancel", this.onTouchEnd);
    this.offcanvasInstance?.dispose();
    this.stopAction();
  }
}
export default MagicRemoteJoystick;
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables.scss";
$size: 72px;

.offcanvas {
  border-top: none !important;
}

.square-joystick-btn {
  width: $size;
  height: $size;
}
/* Анимация нажатия: только пока кнопка зажата */
.btn,
.nav-btn {
  touch-action: manipulation;
  transition: transform 0.12s cubic-bezier(0.34, 1.56, 0.64, 1),
    background-color 0.12s ease, box-shadow 0.12s ease;
}
.btn:active,
.nav-btn:active,
.btn.is-pressed,
.nav-btn.is-pressed {
  transform: scale(0.84);
}

.nav-btn {
  &.up:active,
  &.up.is-pressed {
    transform: translateX(-50%) scale(0.84);
  }
  &.down:active,
  &.down.is-pressed {
    transform: translateX(-50%) scale(0.84);
  }
  &.left:active,
  &.left.is-pressed {
    transform: translateY(-50%) scale(0.84);
  }
  &.right:active,
  &.right.is-pressed {
    transform: translateY(-50%) scale(0.84);
  }
}

.btn:focus,
.btn:focus-visible,
.nav-btn:focus,
.nav-btn:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  color: var(--bs-btn-color) !important;
}

.btn.bg-opacity-05 {
  &:hover,
  &:focus,
  &:focus-visible {
    --bs-bg-opacity: var(--app-btn-opacity);
    background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
    color: $white !important;
  }

  &:active,
  &.is-pressed {
    background-color: rgba($white, 0.35) !important;
    color: $white !important;
    box-shadow: inset 0 6px 14px rgba(0, 0, 0, 0.4) !important;
  }
}

.nav-btn {
  &:active,
  &.is-pressed {
    background-color: rgba($white, 0.3);
    color: $white !important;
    box-shadow: inset 0 6px 14px rgba(0, 0, 0, 0.35) !important;
  }

  &.ok:active,
  &.ok.is-pressed {
    background-color: $white !important;
    color: $primary !important;
    filter: brightness(0.78);
  }
}

/* Навигационное кольцо */
.nav-ring {
  position: relative;
  border-radius: 50%;
  width: 252px;
  height: 252px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-btn {
  position: absolute;
  width: $size;
  height: $size;
  border-radius: 50%;
  border: none;

  &.ok {
    background: $white;
    color: $primary;
    font-weight: bold;
  }
  &.up {
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
  }
  &.down {
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }
  &.left {
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  &.right {
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }

  @media (pointer: fine) {
    &:hover {
      background: rgba($white, 0.1) !important;
      color: $white;
    }
  }
}
</style>
